import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import SpaceInfos from "../../components/wokspaces/spaceinfos";
import RuleSpaces from "../../components/rules/rulesspace";



export default function ViewSpace() {
    // states
    let codespace = useParams();
    const [page, setPage] = useState(0);


    const displayPages = () => {
        if (page === 0) {
            return <SpaceInfos codespace={codespace.code} />;
        } else if (page === 1) {
            return <RuleSpaces space={codespace.code} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {

    }, []);



    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-2 font-weight-bold text_primary">Espaces de travail</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Informations de l'espace de travail</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Droits de l'espace de travail</span>
                </button>
                {/* <button onClick={() => {setPage(2)}} className={`btn-shadow rounded-0 btn ${page === 2 ? 'btn-primary' : 'btn-secondary'}`}>
                                    <span>Profils de l'espace de travail</span>
                                </button> */}
            </div>
            {displayPages()}
        </div>
    )
}